import { createJoonAPIClient } from "../../util/joon-api"

export const markDataTaskAsRead = async (dataTaskId: number) => {
  const API = createJoonAPIClient()
  return API.post(
    `api/parent-training-data-collection-tasks/${dataTaskId}/read/`
  )
}
